import { render, staticRenderFns } from "./CoinProDown.vue?vue&type=template&id=58c8d610&scoped=true"
import script from "./CoinProDown.vue?vue&type=script&lang=js"
export * from "./CoinProDown.vue?vue&type=script&lang=js"
import style0 from "./CoinProDown.vue?vue&type=style&index=0&id=58c8d610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c8d610",
  null
  
)

export default component.exports